import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Observable, of } from "rxjs";
import { BaseRespone, PaginationResult } from "src/app/models/common.response";
import { DoctorSpecialityService } from "./doctor-speciality.service";
import { DoctorSpeciality } from "./idoctor-speciality";
import { LoginService } from "src/app/login.service";
import { ROLE_GROUPS } from "src/app/common/authorization/roles";

@Injectable({
    providedIn: 'root'
})
export class DoctorSpecialityResolver implements Resolve<any> {
    constructor(
        private _doctorSpecialityService: DoctorSpecialityService,
        private _loginService: LoginService
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<BaseRespone<{ pagination: PaginationResult, specialities: DoctorSpeciality[] }> | null> {
        if (!this._loginService.hasAnyRole(ROLE_GROUPS.AllTenant)) {
            return of(null);
        }
        const data = {
            pageNumber: 0,
            pageSize: 100,
        };
        return this._doctorSpecialityService.getAllSpeciality(data);
    }
}